module.exports = __webpack_public_path__ + "img/kakuban_h.2b5bc1f6.png";